import { useTranslation } from 'react-i18next';

import SectionTitle from '../Shared/SectionTitle/SecctionTitle';
import ContactInfo from './ContactInfo/ContactInfo';
import ContactForm from '../Contact/ContactForm/ContactForm';
import classes from './Contact.module.css';

const Contact = (props)=>{
    const {t} = useTranslation();

    return (
        <section id="contact" className={classes.Contact}>
            <div className="container">
            <SectionTitle subtitle={t('contact.subtitle')} title={t('contact.title')}/>
            <div className={classes.ContactCard} data-aos="zoom-in">
                <ContactInfo />
                <ContactForm />
            </div>
            </div>
        </section>
    );
}

export default Contact;